module.exports = __webpack_public_path__ + "img/Tail_feathers_MetalRoughness.0baf51a.jpg";